<template>
  <div class="tlive-livetype__contanier">
    <div
      v-for="item in liveType"
      :key="item.type"
      @click="setLiveType(item.type)"
      class="tlive-livetype--item"
      :class="{'is-active':item.type === value}"
    >
      <yxt-svg
        width="24px"
        height="24px"
        :remote-url="remoteUrl"
        :icon-class="item.svgName"
      />
      <span>
        {{ item.name }}
      </span>
      <yxt-svg
        v-if="item.type === value"
        class="tlive-livetype--tick"
        width="14px"
        height="14px"
        :remote-url="remoteUrl"
        icon-class="tick"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LiveType',
  props: {
    value: {
      type: String,
      default: 'pc'
    }
  },
  data() {
    return {
      liveType: [
        { type: 'pc', name: this.$t('pc_biz_pclive' /* 电脑直播*/), svgName: 'pc_live3' },
        { type: 'mobile', name: this.$t('pc_biz_mobilelive' /* 手机直播*/), svgName: 'mobile_live2' }
      ],
      remoteUrl: `${this.$staticBaseUrl}ufd/989eac/tlive/pc/svg/`
    };
  },
  methods: {
    setLiveType(type) {
      this.$emit('input', type);
    }
  }
};
</script>
<style scoped lang="less"></style>
